import { render } from "./LeaveAssign.vue?vue&type=template&id=61cb7fea&scoped=true"
import script from "./LeaveAssign.vue?vue&type=script&lang=js"
export * from "./LeaveAssign.vue?vue&type=script&lang=js"

import "./LeaveAssign.vue?vue&type=style&index=0&id=61cb7fea&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61cb7fea"]])

export default __exports__